import $ from "jquery";
import moment from "moment";
import "eonasdan-bootstrap-datetimepicker";
import Seed from "DMS/Seed/All";
import { initializeSearchKendo } from "DMS/Controllers/kendoController";
import { decodeParam } from "DMS/Utils/parameter";
import * as resizeScreen from "DMS/Utils/resizeScreen";
import { isSmallDevice } from "DMS/Utils/checkFeatures";
import { rqListKendo, changeFilterKendo, refreshListKendo, clearFiltersKendo } from "DMS/Controllers/kendoController";
export function isSmartList() {
    return (Seed.Tab.GetFrame().find('.smartCore').length > 0) || moduleType === "Localisation";
}
//************ controller *****************
// Appelé par AC_LIST
export function callList(tabName, numAction, sImport) {
    Seed.Tab.AddTab();
    Seed.Tab.SetText(tabName);
    Seed.Tab.SetCallback(function callb() {
        rqList('mydiv', Seed.Tab.GetOffset(), numAction, '', sImport);
    });
    rqListSearch(numAction, sImport);
}
// Appelé par ListSearch.php
export function initializeSearch() {
    var pTarget = Seed.Tab.GetFrame();
    datePicker();
    // Collapse
    $(pTarget).find('.collapse')
        .on('shown.bs.collapse', function () {
        resizeScreen.launchOnHeightResized();
    })
        .on('hidden.bs.collapse', function () {
        resizeScreen.launchOnHeightResized();
    });
    if (!isSmartList()) {
        initializeSearchKendo(pTarget);
    }
    // Resize
    resizeScreen.resizeScreen();
}
/**
 * Réinitialisation des champs de recherche
 */
export function initField() {
    var searchform = Seed.Tab.GetFrame().find('div#recherche');
    if (searchform) {
        var searchchilds = searchform.find("INPUT");
        for (var i = 0; i < searchchilds.length; i++) {
            searchchilds[i].value = "";
        }
        var searchchilds = searchform.find("SELECT");
        for (var i = 0; i < searchchilds.length; i++) {
            searchchilds[i].value = "";
        }
    }
    // Zone en création
    searchform.find('.has-error').removeClass('has-error');
}
//****** MODULE POTENTIEL ************/
/**
 * Afficher la zone de recherche au dessus d'une liste
 * @param {int} numaction numéro de l'action
 * @param {array} pImport Valeurs importés
 * @param {} div
 */
export function rqListSearch(numaction, pImport, div) {
    var sImport = "";
    if (pImport) {
        var pImportLength = pImport.length;
        for (var i = 0; i < pImportLength; i++) {
            pImport[i][1] = decodeParam(pImport[i][1]);
            sImport += "&" + pImport[i][0] + "=" + encodeURIComponent(pImport[i][1]);
        }
    }
    if (numaction === 3060) {
        root = '../../'; // @todo : ???
    }
    if (!div) {
        div = document.getElementById("tab_" + Seed.Tab.cTab.attr("id"));
    }
    div.innerHTML = "";
    Seed.Ajax.Post({
        url: root + "_module/ListAndForm/ListCore.php",
        data: sImport + "&numaction=" + numaction + "&moduleType=" + moduleType,
        json: true,
        async: true,
        success: (xml) => {
            div.innerHTML = xml.html;
            div.style.visibility = "visible";
            var jscript = document.createElement("SCRIPT"); // BALISE SCRIPT
            jscript.text = xml.jscript;
            div.appendChild(jscript); // AJOUT DU SCRIPT AU DOCUMENT
            $(div).find('.buttonBar:empty').parent().hide();
            // Planning
            if (numaction === 3045 || numaction === 3060) {
                // Taille des boutons
                Seed.Tab.GetFrame().find('div.tableRecherche>div.row>div').removeClass().addClass('col-lg-12');
                Seed.Tab.GetFrame().find('div.panel-footer>div.row>div').removeClass().addClass('col-lg-12');
            }
            if (numaction === 3060) {
                Seed.Tab.GetFrame().find("#mydiv").addClass("resizable");
            }
            // Id du div / OFFSET / Action / Orderby / Variables importees
            rqList("mydiv", 0, numaction, "", pImport);
        }
    });
}
/**
 * Afficher une liste
 * @param {type} nomdiv
 * @param {type} offset
 * @param {type} numaction
 * @param {type} pOrderby
 * @param {type} pImport
 */
export function rqList(nomdiv, offset, numaction, pOrderby, pImport) {
    let isMobileType = isSmallDevice();
    var urlEnding;
    if (isMobileType || isSmartList() ||
        (numaction === 3045) ||
        (numaction === 3060)) {
        // Planning & smartphone & localisation
        urlEnding = "_module/SmartVersion/SmartCore.php";
        if (!offset) {
            offset = -1;
        }
        Seed.Tab.SetOffset(offset);
        var elements = "";
        var searchform = Seed.Tab.GetFrame().find("div#recherche");
        if (searchform.length !== 0) {
            var inputs = searchform.find("input,select");
            for (var i = 0; i < inputs.length; i++) {
                var idElt = $(inputs[i]).attr("id").split('_')[2];
                var value = $(inputs[i]).val();
                if ($(inputs[i]).hasClass('SM-datepicker') && value.length !== 0) {
                    value = moment.utc(value, 'L').format("YYYY/MM/DD");
                }
                if (value) {
                    elements += "&" + idElt + "=" + encodeURIComponent(value);
                }
            }
        }
        // Récuperer Liste de valeurs des champs Filtrer!= null
        // et alimenter la combo.
        var sImport = "";
        if (pImport) {
            var pImportLength = pImport.length;
            for (var i = 0; i < pImportLength; i++) {
                pImport[i][1] = decodeParam(pImport[i][1]);
                value = pImport[i][1];
                if (value) {
                    sImport += "&" + pImport[i][0] + "=" + encodeURIComponent(value);
                }
            }
        }
        var div;
        if (nomdiv === "mydiv") {
            div = Seed.Tab.SearchNode(nomdiv, "DIV");
        }
        // @todo : ckecker l'utilité de ce bloc ^_^
        var offsetTop = 0;
        if (!div) {
            console.log("rqList: ERREUR");
        }
        else {
            offsetTop = div.offsetTop;
        }
        var orderBy = "";
        if (pOrderby) {
            orderBy = pOrderby;
            Seed.Tab.SetOrder(pOrderby);
        }
        else {
            orderBy = Seed.Tab.GetOrder();
        }
        var topSearch = 0;
        var searchPanel = Seed.Tab.GetFrame().find('.panel.panel-primary');
        if (searchPanel.length !== 0) {
            topSearch = searchPanel.offset().top;
        }
        Seed.Ajax.Post({
            url: root + urlEnding,
            data: sImport
                + "&nomdiv=" + nomdiv
                + "&numaction=" + numaction
                + "&offset=" + offset
                + elements
                + sImport
                + "&orderBy=" + orderBy
                + "&Top=" + offsetTop
                + "&moduleType=" + moduleType,
            json: true,
            async: true,
            success: function (xml) {
                $(div).html("");
                $(div).append(xml.html);
                var jscript = document.createElement("SCRIPT");
                jscript.text = xml.jscript;
                Seed.Tab.GetFrame().append(jscript);
                // Planning
                if (numaction === 3045) {
                    // Suppress ButonBar
                    $(div).find('.panel[id^="listSearch-"]')
                        .prev()
                        .remove();
                    $(div).find('.panel-group')
                        .find('div.panel.panel-primary[id^=toFade]')
                        .addClass('taskDrop');
                    // Resizable sur la liste
                    var $thisFrame = $(Seed.Tab.GetFrame());
                    $thisFrame.find('#div_result')
                        .addClass('resizable');
                    $thisFrame.find('.panel[id^="listSearch-"]')
                        .on('hidden.bs.collapse', function () {
                        resizeScreen.resizeScreen();
                    });
                    $thisFrame.find('.panel[id^="listSearch-"]')
                        .on('shown.bs.collapse', function () {
                        resizeScreen.resizeScreen();
                    });
                    var elements = $(div).find(".taskDrop");
                    elements.draggable({
                        containment: $thisFrame.find('#planning-wrapper'),
                        cursor: "move",
                        snap: ".tacheDroppable",
                        cursorAt: { top: 0, left: 50 },
                        helper: function (event) {
                            var currentTarget = event.currentTarget;
                            var numDossier = $(currentTarget)
                                .find('div[name="numdossier"]')
                                .text();
                            var nomclientLivraison = $(currentTarget)
                                .find('div[name="nomclientlivraison"]')
                                .text();
                            var panel = "<div class=\'ui-widget-header\'"
                                + "       style=\'width: 90px; height: 15px;\'>"
                                + numDossier + ' - ' + nomclientLivraison
                                + " </div>";
                            return $(panel);
                        },
                        // pour que le "helper" passe au-dessus de la grille du planning .planning-panel
                        appendTo: $thisFrame.find('.planning-panel'),
                        zIndex: 300
                    });
                    Seed.Planning.locking();
                    Seed.Planning.formatData();
                    if (!Seed.Planning.isCartVisible()) {
                        Seed.Planning.hideCart();
                    }
                }
                resizeScreen.resizeScreen();
            }
        });
    }
    else {
        rqListKendo(nomdiv, offset, numaction, pOrderby, pImport);
    }
}
/**
 * Change chevron of Panel accordion
 * @param {type} id ID du panel colapse
 */
export function changeChevron(id) {
    if ($("#" + id).hasClass('collapsed'))
        $("#" + id + " .fa").removeClass("fa-chevron-down").addClass("fa-chevron-right");
    else
        $("#" + id + " .fa").removeClass("fa-chevron-right").addClass("fa-chevron-down");
}
export function changeFilter(event, input) {
    Seed.Tab.GetCurrentTab().alreadyFilter = true;
    if (!isSmartList()) {
        changeFilterKendo(event, input);
        Seed.Tab.GetCurrentTab().alreadyFilter = false;
    }
    else if (!isSmartList()) {
        if ((event.type === "keypress") && (event.keyCode !== 13)) {
            return 0;
        }
    }
}
export function refreshList(importedVar = []) {
    if (!isSmartList()) {
        refreshListKendo();
    }
    else {
        var numaction = parseInt(Seed.Tab.GetFrame().find(".tableRecherche").attr("data-numaction"));
        rqList("mydiv", 0, numaction, "", importedVar);
    }
}
export function clearFilters(nomGrid) {
    if (!isSmartList()) {
        clearFiltersKendo(nomGrid);
    }
    else {
        initField();
        refreshList();
    }
}
export function initList() {
    initField();
    Seed.Tab.SetOrder("");
    clearFilters();
    // ajout des valeurs des filtres par defaut (colonne recherchedefaut de yinterface)
    let searchformJqueryObj = Seed.Tab.GetFrame().find('#recherche');
    if (searchformJqueryObj.length > 0) {
        let defaultEvent = { 'type': 'click' };
        searchformJqueryObj.find('input, select').each(function () {
            if (this.hasAttribute('data-recherchedefaut-value')) {
                this.value = this.getAttribute('data-recherchedefaut-value');
                changeFilter(defaultEvent, this);
            }
        });
    }
}
/**
 * Get the filter in text mode
 * @returns {String} filter in text mode
 */
export function getFilters() {
    var elements = "";
    var searchform = Seed.Tab.GetFrame().find("div#recherche");
    if (searchform.lenght !== 0) {
        var inputs = searchform.find("input,select");
        for (var i = 0; i < inputs.length; i++) {
            var idElt = $(inputs[i]).attr("id").split('_')[2];
            var value = $(inputs[i]).val();
            if ($(inputs[i]).hasClass('SM-datepicker') && value.length !== 0) {
                value = moment.utc(value, 'L').format("YYYY/MM/DD");
            }
            if (value) {
                elements += "&" + idElt + "=" + encodeURIComponent(value);
            }
        }
    }
    return elements;
}
export function datePicker() {
    var pTarget = Seed.Tab.GetFrame();
    pTarget.find('[name="dateinput"]')
        .on('dp.hide', function (e) {
        $(this).trigger('change');
    });
    pTarget.find('[name="dateinput"]')
        .on('dp.hide', function (e) {
        $(this).trigger('change');
    });
    pTarget.find('[name="dateinput"]')
        .on('dp.hide', function (e) {
        $(this).trigger('change');
    });
    // Date
    $(pTarget).find(".SM-datepicker").datetimepicker({
        locale: moment.locale(),
        icons: {
            time: 'fa fa-clock-o',
            date: 'fa fa-calendar-o',
            up: 'fa fa-arrow-up',
            down: 'fa fa-arrow-down',
            previous: 'fa fa-angle-left',
            next: 'fa fa-angle-right',
            today: 'fa fa-crosshairs',
            clear: 'fa fa-trash'
        },
        showTodayButton: true,
        showClear: true,
        format: "L",
        useCurrent: false
    });
}
//# sourceMappingURL=listController.js.map